module.exports = __webpack_public_path__ + "static/img/K.c049f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/K.png
// module id = 7lMT
// module chunks = 0